import { createFileRoute } from '@tanstack/react-router';

import ExportTemplates from '@/areas/sourcing-scenarios/ExportTemplates/ExportTemplatesPage';
import { canViewExportTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/templates/_sidebar/export')({
    staticData: { access: { permissions: canViewExportTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ExportTemplates />;
}
